// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;

import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './components/auth/AuthContext';
import GovernmentLogin from './components/GovernmentLogin';
import AdminDashboard from './components/AdminDashboard';
import { CssBaseline } from '@mui/material';
import AOS from 'aos';
import 'aos/dist/aos.css';
import SchoolDetails from './components/SchoolDetails';
import DeletedSchools from './components/DeletedSchools';
import AdminSupportDashboard from './components/AdminSupportDashboard';
import AdminSupportChat from './components/AdminSupportChat';
import AllAmplifiedEvents from './components/AllAmplifiedEvents';
import AllScholarships from './components/AllScholarships';
import AmplifiedEventDetails from './components/AmplifiedEventDetails';
import ScholarshipDetails from './components/ScholarshipDetails';
import PublishAmplifiedEvent from './components/PublishAmplifiedEvent';
import PublishScholarship from './components/PublishScholarship';
import UploadTeacherResource from './components/UploadTeacherResource';
import AdminVideos from './components/AdminVideos';
import AdminVideoUpload from './components/AdminVideoUpload';

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true
    });
  }, []);

  return (
    <AuthProvider>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/government-login" element={<GovernmentLogin />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="*" element={<GovernmentLogin />} />
          <Route path="/school-details/:id" element={<SchoolDetails />} />
          <Route path="/school-details" element={<SchoolDetails />} />
          <Route path="/deleted-schools" element={<DeletedSchools />} />
          <Route path="/admin-support-dashboard" element={<AdminSupportDashboard />} />
          <Route path="/admin-support-chat" element={<AdminSupportChat />} />
          <Route path="/admin-support-chat/:conversationId" element={<AdminSupportChat />} />
          <Route path="/amplified-events" element={<AllAmplifiedEvents />} />
          <Route path="/amplified-event-details" element={<AmplifiedEventDetails />} />
          <Route path="/publish-amplified-event" element={<PublishAmplifiedEvent />} />
          <Route path="/publish-scholarship" element={<PublishScholarship />} />
          <Route path="/upload-teacher-resource" element={<UploadTeacherResource />} />
          <Route path="/admin-videos" element={<AdminVideos />} />
          <Route path="/admin-video-upload" element={<AdminVideoUpload />} />
          
          {/* Scholarship Routes */}



          <Route path="/scholarships" element={<AllScholarships />} />
          <Route path="/scholarship-details" element={<ScholarshipDetails />} />

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;